import expertImg from '@assets/images/expert/expert-bg.jpg'
//const expertImg = null

import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

function useFadeIn() {
  const ref = useRef(null)
  const [vis, setVis] = useState(false)
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVis(true) }, { threshold: 0.1 })
    if (ref.current) obs.observe(ref.current)
    return () => obs.disconnect()
  }, [])
  return [ref, vis]
}

export default function ExpertSection() {
  const [ref, vis] = useFadeIn()

  return (
    <section ref={ref} style={{
      position: 'relative',
      width: '100%',
      overflow: 'hidden',
      opacity: vis ? 1 : 0,
      transition: 'opacity 0.7s ease',      
      background: '#ffffff'
    }}>

      {/* Full-width image — takes full section width */}
      <div style={{
        width: '55%',
        minHeight: 'clamp(280px, 35vw, 460px)',
        background: expertImg
          ? `url(${expertImg}) center/cover no-repeat`
          : 'linear-gradient(135deg, #e8e4e0 0%, #d4cec9 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
        className="expert-img"
      >
        {!expertImg && (
          <div style={{
            position: 'absolute', inset: 0,
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', gap: '10px',
          }}>
            <svg width="52" height="52" viewBox="0 0 24 24" fill="none"
              stroke="#b0aaa4" strokeWidth="1" strokeLinecap="round">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
            <p style={{
              fontFamily: "'DM Sans',sans-serif", fontSize: '11px',
              color: '#b0aaa4', margin: 0
            }}>
              src/assets/images/expert/expert-bg.jpg
            </p>
          </div>
        )}
      </div>

      {/* Green box — floats RIGHT, overlapping image */}
      <div style={{
        position: 'absolute',
        top: '50%',
        right: 0,
        transform: 'translateY(-50%)',
        width: '55%',
        background: '#007935',
        padding: 'clamp(28px, 4vw, 48px) clamp(24px, 4vw, 52px)',
        zIndex: 2,
      }}
        className="expert-box"
      >
        {/* Small uppercase label */}
        <p style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '15px', fontWeight: 400,
          letterSpacing: '0.13em', textTransform: 'uppercase',
          color: 'rgba(255,255,255,0.6)',
          margin: '0 0 14px',
        }}>
          Tested Quality
        </p>

        <h2 style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: 'clamp(1.75rem, 3vw, 2.1rem)',
          fontWeight: 400, color: '#1a1a18',
          letterSpacing: '0.04em', textTransform: 'uppercase',
          color: '#ffffff', margin: '0 0 6px',

        }}>
          Expert knowledge for premium products.
        </h2>

        <p style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: 'clamp(13px, 1.2vw, 15px)',
          color: 'rgba(255,255,255,0.80)',
          lineHeight: 1.7,
          margin: '0 0 24px',
        }}>
          High quality also means high security for our customers. For this reason,
          we are happy to invest in quality. At Salient, we guarantee product
          safety right from the start.
        </p>

        <Link
          to="/about"
          style={{
            display:        'inline-flex', alignItems: 'center',
            fontFamily:     "'DM Sans', sans-serif",
            fontSize:       '13px', fontWeight: 600,
            color:          '#007935', textDecoration: 'none',
            padding:        '8px 18px',
            border:         '1.5px solid rgba(255,255,255,0.75)',
            background:     '#ffffff',
            transition:     'background 0.2s ease',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.75)' }}
          onMouseLeave={e => { e.currentTarget.style.background = '#ffffff' }}
        >
          Get more infos
        </Link>
      </div>

      <style>{`
        @media (max-width: 767px) {
          .expert-img { width: 100% !important; min-height: 220px !important; }
          .expert-box {
            position: relative !important;
            top: auto !important; right: auto !important;
            transform: none !important;
            width: 100% !important;
          }
        }
      `}</style>
    </section>
  )
}